import { useRef, useState } from "react";
import { api, API, formatErr } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Upload, X, Loader2 } from "lucide-react";

export default function FileUploader({ kind = "product", accept = "image/*", value = "", onChange, label = "Upload", preview = true }) {
  const inputRef = useRef();
  const [busy, setBusy] = useState(false);

  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      fd.append("kind", kind);
      const { data } = await api.post("/uploads", fd, { headers: { "Content-Type": "multipart/form-data" } });
      const fullUrl = `${API}/files/${data.path}`;
      onChange?.(fullUrl);
      toast.success("Uploaded");
    } catch (e) {
      toast.error(formatErr(e));
    } finally { setBusy(false); }
  };

  const clear = () => onChange?.("");
  const url = value ? (value.startsWith("http") || value.startsWith("/api") ? value : `${API}/files/${value}`) : "";

  return (
    <div>
      <input ref={inputRef} type="file" accept={accept} className="hidden"
             onChange={(e) => upload(e.target.files?.[0])} data-testid={`${kind}-upload-input`} />
      <div className="flex items-start gap-3">
        {preview && url && (
          <div className="relative h-20 w-20 overflow-hidden rounded-lg border border-slate-200 bg-slate-50">
            {accept.includes("image") ? (
              <img src={url} alt="preview" className="h-full w-full object-cover" />
            ) : (
              <div className="flex h-full w-full items-center justify-center text-[10px] font-semibold text-slate-500">PDF</div>
            )}
            <button type="button" onClick={clear} className="absolute right-0 top-0 rounded-bl bg-red-600 p-0.5 text-white" data-testid={`${kind}-clear-btn`}>
              <X className="h-3 w-3" />
            </button>
          </div>
        )}
        <Button type="button" variant="outline" onClick={() => inputRef.current?.click()} disabled={busy} data-testid={`${kind}-upload-btn`}>
          {busy ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <Upload className="mr-2 h-4 w-4" />}
          {value ? "Replace" : label}
        </Button>
      </div>
    </div>
  );
}
